import styled, { css } from 'styled-components';
import dynamic from 'next/dynamic';

import { FitFeedbackProvider } from 'productTemplate/providers/FitFeedbackProvider';
import { t } from 'localization/utils/t';
import { useFitFeedback } from 'productTemplate/hooks/useFitFeedback';

const FitFeedbackWindow = dynamic(
  () => import('productTemplate/components/fitFeedback/FitFeedbackWindow'),
  {
    ssr: false,
  },
);

const FitFeedbackFormWindow = dynamic(
  () =>
    import('productTemplate/components/fitFeedback/FitFeedbackFormWindow').then(
      (mod) => mod.FitFeedbackFormWindow,
    ),
  {
    ssr: false,
  },
);

const ClientOnlyPortal = dynamic(
  () => import('shared/components/ClientOnlyPortal').then((mod) => mod.ClientOnlyPortal),
  {
    ssr: false,
  },
);

const TP = 'productTemplate.components.fitFeedback.FitFeedbackWindow';

const MobileFitButton = () => {
  const {
    fitWindowState,
    handleFitClick,
    handleFitClose,
    isApparelFitFeedbackEnabled,
    isFitFeedbackFormWindowVisible,
    isSneakersFitFeedbackEnabled,
  } = useFitFeedback();

  return (
    <MobileFitButton.Wrapper $isOpen={fitWindowState.isOpen}>
      {(isApparelFitFeedbackEnabled || isSneakersFitFeedbackEnabled) && (
        <button data-qa="product_template_fit_button" onClick={handleFitClick} type="button">
          {t(`${TP}.fit`, 'Fit')}
        </button>
      )}

      {isFitFeedbackFormWindowVisible && (
        <ClientOnlyPortal selector="#main-page-layout">
          <FitFeedbackFormWindow />
        </ClientOnlyPortal>
      )}
      {fitWindowState?.isOpen && (
        <ClientOnlyPortal selector="#main-page-layout">
          <FitFeedbackWindow isPermanent={fitWindowState.isPermanent} onClose={handleFitClose} />
        </ClientOnlyPortal>
      )}
    </MobileFitButton.Wrapper>
  );
};

export const MobileFitInfo = () => {
  return (
    <FitFeedbackProvider>
      <MobileFitButton />
    </FitFeedbackProvider>
  );
};

MobileFitButton.Wrapper = styled.div<{ $isOpen?: boolean }>`
  display: flex;

  button {
    padding: 10px 8px;
    margin-top: -10px;

    ${({ $isOpen }) =>
      $isOpen &&
      css`
        text-decoration: underline;
      `}
  }
`;
